import { ReactComponent as ZoomInSvg } from "app/assets/images/icons/zoom-in.svg";
import { ReactComponent as ZoomOutSvg } from "app/assets/images/icons/zoom-out.svg";
import { Chart } from "chart.js";
import { zoom } from "chartjs-plugin-zoom";
import React from "react";
import { ERROR_BOUNDARY_MESSAGES } from "utils/constants";
import { rollbar } from "utils/jwtClient";

type ZoomControlsProps = {
  chart: Chart;
  title: string;
};

export const ZoomControls: React.FC<ZoomControlsProps> = ({ chart, title }) => {
  const handleZoom = (zoomFactor: number) => {
    try {
      zoom(chart, zoomFactor, "default");
    } catch (e) {
      rollbar.warning(ERROR_BOUNDARY_MESSAGES.chartjs, e);
    }
  };

  return (
    <div className="chart__controls">
      <p className="small text text__secondary chart__title">{title}</p>
      <div className="chart__buttons">
        <button
          className="chart__button"
          onClick={() => {
            handleZoom(1.5);
          }}
        >
          <ZoomInSvg className="chart__button-icon" aria-label="zoom in" />
        </button>
        <button
          className="chart__button"
          onClick={() => {
            handleZoom(-1.5);
          }}
        >
          <ZoomOutSvg className="chart__button-icon" aria-label="zoom out" />
        </button>
      </div>
    </div>
  );
};
